<template>
  <b-modal
    ref="modalCadastroOportunidadeInstance"
    title="Cadastre uma nova jornada"
    size="md"
    no-close-on-backdrop
    :footer-class="'custom-footer-class'"
    :dialog-class="'alteracao-tamanho'"
    :modal-class="'center-modal'"
  >
    <div
      style="display: flex; flex-direction: column; align-items: center; gap: 1rem; width: 100%;"
    >
      <div style="width: 100%;" />

      <div style="width: 100%;">
        <empresa-cnpj-select
          v-model="novaOportunidade.company"
          :label="'Empresa'"
          :exibir-botao-criar-pessoa="false"
          :pessoa="novaOportunidade.person"
          @input="empresaSelecionadaViaCnpj"
          @empresa-criada="empresaSelecionadaViaCnpj"
          @pessoa-criada="pessoaCriada"
        />
      </div>

      <div>
        - ou -
      </div>

      <div style="width: 100%;">
        <div class="d-flex align-items-center">
          <label
            for="pessoaSelect"
            class="mb-0"
          >
            Pessoa
          </label>
          <span
            class="d-flex align-items-center justify-content-center"
            style="width: 35px; height: 24px;"
          >
            <b-button
              v-b-tooltip.hover.top="'Criar pessoa responsável'"
              size="sm"
              variant="none"
              class="btn-actions p-0"
              style="width: 24px; height: 24px;"
              @click="abrirModalCriarPessoa"
            >
              <font-awesome-icon
                :icon="faPlus"
                :class="'text-primary'"
                style="width:18px"
              />
            </b-button>
          </span>
        </div>

        <pessoa-select
          ref="pessoaSelect"
          v-model="novaOportunidade.person"
          :label="''"
          style="width: 100%;"
        />
      </div>
    </div>

    <template #modal-footer>
      <b-button
        block
        size="md"
        class="btn-criar"
        variant="primary"
        @click="cadastrarNovaOportunidade"
      >
        Criar
      </b-button>
    </template>
  </b-modal>
</template>
<style scoped>
</style>
<script>
import { getUserInfo } from '@/auth/utils'
import api from '@/app-modulo/comercial/oportunidades/shared/services/api'
import empresaApi from '@/app-modulo/comuns/empresa/shared/services/api'
import { novaOportunidadeBase as buildNovaOportunidadeBase } from '@/app-modulo/comercial/oportunidades/shared/utils'

export default {
  name: 'ModalCadastroOportunidade',

  components: {
    EmpresaCnpjSelect: () => import('@/shared/components/empresa-cnpj-select/EmpresaCnpjSelect.vue'),
    PessoaSelect: () => import('@/shared/components/pessoa-select/PessoaSelect.vue'),
  },
  props: {
    funis: {
      type: Array,
      default: () => [],
    },
    funilSelecionado: {
      type: [Number, String],
      default: null,
    },
  },
  emits: ['oportunidade-criada', 'solicitar-criacao-pessoa', 'empresa-atualizada'],
  data() {
    return {
      novaOportunidade: buildNovaOportunidadeBase(),
      faPlus: ['fas', 'plus'],
    }
  },
  methods: {
    showModal() {
      this.$refs.modalCadastroOportunidadeInstance.show()
    },
    hideModal() {
      this.$refs.modalCadastroOportunidadeInstance.hide()
    },
    resetNovaOportunidade() {
      this.novaOportunidade = buildNovaOportunidadeBase()
      this.$emit('empresa-atualizada', null)
    },
    validarNovaOportunidade() {
      if (!this.novaOportunidade.company && !this.novaOportunidade.person) {
        this.$erro('Informe uma empresa ou uma pessoa.')
        return false
      }
      return true
    },
    async cadastrarNovaOportunidade() {
      if (!this.validarNovaOportunidade()) return false

      const pipelineId = this.funilSelecionado
      if (!pipelineId) {
        this.$erro('Selecione um funil antes de criar uma oportunidade.')
        return false
      }

      this.novaOportunidade.companyId = this.novaOportunidade.company ? this.novaOportunidade.company.id : 0
      this.novaOportunidade.personId = this.novaOportunidade.person ? this.novaOportunidade.person.id : 0
      this.novaOportunidade.pipelineId = pipelineId

      const selectedFunil = Array.isArray(this.funis)
        ? this.funis.find(funil => String(funil.id) === String(pipelineId))
        : null

      if (!selectedFunil) {
        this.$erro('Funil selecionado não encontrado.')
        return false
      }

      const firstStageId = selectedFunil.stages && selectedFunil.stages[0]
        ? selectedFunil.stages[0].id
        : null

      if (!firstStageId) {
        this.$erro('Funil selecionado não possui etapas.')
        return false
      }

      const payload = {
        title: this.novaOportunidade.title,
        estimatedValue: this.novaOportunidade.estimatedValue,
        companyId: this.novaOportunidade.companyId || null,
        personId: this.novaOportunidade.personId || null,
        pipelineId: this.novaOportunidade.pipelineId,
        stageId: firstStageId,
        ownerId: getUserInfo().id,
      }

      return api.createDeal(firstStageId, payload)
        .then(response => {
          const oportunidadeCriada = response && response.data ? response.data : null
          this.$sucesso('Oportunidade cadastrada com sucesso.')
          this.$emit('oportunidade-criada', oportunidadeCriada)
        })
        .catch(err => {
          const data = err?.response?.data
          const backendMessage = data?.detail
            || data?.message
            || data?.title
            || (typeof data === 'string' ? data : null)
            || err?.message
            || 'Erro ao cadastrar oportunidade, tente novamente mais tarde.'
          this.$erro(backendMessage)
        })
        .finally(() => {
          this.resetNovaOportunidade()
          this.hideModal()
        })
    },
    empresaSelecionadaViaCnpj(empresa) {
      this.novaOportunidade.company = empresa || null
      this.novaOportunidade.person = null
      this.$emit('empresa-atualizada', this.novaOportunidade.company)

      if (empresa && empresa.id) {
        this.carregarPessoasDaEmpresa(empresa.id)
      }
    },
    async carregarPessoasDaEmpresa(empresaId, pessoaPreferidaId = null) {
      try {
        const response = await empresaApi.getPessoasEmpresa(empresaId)
        const pessoas = response.data || []

        if (this.$refs.pessoaSelect?.recarregarItens) {
          await this.$refs.pessoaSelect.recarregarItens()
        }

        if (pessoas.length > 0) {
          const preferida = pessoaPreferidaId
            ? pessoas.find(p => String(p.id) === String(pessoaPreferidaId))
            : null
          this.novaOportunidade.person = preferida || pessoas[0]
        }
      } catch (error) {
        this.$erro('Nao foi possivel carregar as pessoas vinculadas a essa empresa.')
      }
    },
    async pessoaCriada(pessoaData) {
      if (!pessoaData) return
      if (this.$refs.pessoaSelect?.recarregarItens) {
        await this.$refs.pessoaSelect.recarregarItens()
      }
      this.novaOportunidade.person = pessoaData
      if (this.$sucesso) this.$sucesso('Pessoa criada com sucesso!')
    },
    abrirModalCriarPessoa() {
      const empresaId = this.novaOportunidade.company ? this.novaOportunidade.company.id : null
      this.$emit('solicitar-criacao-pessoa', empresaId)
    },
  },
}
</script>
